const SectionHeader = ({ subline, headline, invertedColors = false }) => {
  return (
      <div className={`section-header mb-10 ${invertedColors ? 'inverted' : ''}`}>
      
      {/* Subline */}
      <h3 className="subline">
        {subline}
      </h3>
      
      {/* Divider */}
      <div className="divider"></div> 
      
      {/* Headline */}
      <h2 className="headline">
        {headline}
      </h2>
    </div>
  );
};

export { SectionHeader };